import { render, staticRenderFns } from "./SwitchCellRenderer.vue?vue&type=template&id=3dadfd65&"
import script from "./SwitchCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./SwitchCellRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports